import { render, staticRenderFns } from "./OtherOfficeMessageReplyInput.vue?vue&type=template&id=0c57326e&scoped=true&lang=pug"
import script from "./OtherOfficeMessageReplyInput.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeMessageReplyInput.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeMessageReplyInput.vue?vue&type=style&index=0&id=0c57326e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57326e",
  null
  
)

export default component.exports